<template>
  <v-row>
    <v-col class="mt-2" cols="12" offset-lg="1" lg="10">
      <v-breadcrumbs :items="breadcrumbs" divider=">" class="pl-1 pb-3" />
      <v-card>
        <v-card-title class="theme">
          <v-icon class="white--text">receipt_long</v-icon>
          <span class="headline ml-2 white--text">Add department</span>
        </v-card-title>
        <v-divider />
        <v-card-text>
          <v-form ref="form">
            <v-container>
              <v-row>
                <v-col cols="12" md="5">
                  <v-text-field
                    label="Department Name*"
                    persistent-hint
                    :rules="[validationRules.required]"
                    :disabled="tempDisable"
                    hint="Name of the department e.g. Accounts"
                    v-model="department.name"
                    class="my-4"
                  >
                    <template v-slot:append-outer>
                      <v-tooltip right>
                        <template v-slot:activator="{ on }">
                          <v-icon small class="grey--text pt-1" v-on="on"
                            >help</v-icon
                          >
                        </template>
                        Provide a name for the department.
                      </v-tooltip>
                    </template>
                  </v-text-field>

                  <v-textarea
                    label="Additional information"
                    :disabled="tempDisable"
                    persistent-hint
                    rows="4"
                    v-model="department.description"
                    class="my-4"
                  >
                    <template v-slot:append-outer>
                      <v-tooltip right>
                        <template v-slot:activator="{ on }">
                          <v-icon small class="grey--text pt-1" v-on="on"
                            >help</v-icon
                          >
                        </template>
                        Any additional information for your reference.
                        <br />This will not be displayed anywhere else.
                      </v-tooltip>
                    </template>
                  </v-textarea>
                </v-col>
                <v-col cols="12" md="7"></v-col>
              </v-row>
              <v-btn
                depressed
                class="save rounded-sm white--text ml-0"
                @click="save"
                >save</v-btn
              >
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-col>

    <v-snackbar v-model="snackbar" :bottom="true" :right="true">
      {{ snackbarMessage }}
      <v-btn color="pink" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-row>
</template>
<script>
import { mapGetters } from "vuex";

import { Actions } from "@/views/actions";
import { Breadcrumbs } from "@/views/breadcrumbs";
import { Component } from "@/views/component";
import { Constants } from "@/views/constants";

export default {
  name: Component.Protected.Company.Departments.Add,
  data: () => ({
    breadcrumbs: Breadcrumbs.Departments.Add,
    tempDisable: false,
    department: {
      name: "",
      description: "",
      count: 0,
    },
  }),
  computed: {
    ...mapGetters(["userInfo"]),
  },
  methods: {
    save() {
      if (this.$refs.form.validate()) {
        const data = { ...this.department };
        this.tempDisable = true;
        this.$store
          .dispatch(Actions.DepartmentAdd, data)
          .then(() => this.$router.go(-1))
          .catch((e) => {
            console.error(Constants.Departments.Messages.Error.Add, e);
            this.snackbarMessage = Constants.Departments.Messages.Error.Add;
            this.snackbar = true;
          })
          .finally(() => (this.tempDisable = false));
      }
    },
    back() {
      this.$router.go(-1);
    },
    setup() {
      if (this.userInfo.role !== Constants.Roles.HR) {
        this.$router.go(-1);
        return false;
      }
      this.tempDisable = false;
    },
  },
  created() {
    if (this.userInfo && this.userInfo.role) {
      this.setup();
    } else {
      this.$store.dispatch(Actions.Firebase.UserInfo).then(() => this.setup());
    }
  },
};
</script>